import { render, staticRenderFns } from "./DeleteDrinkDialog.vue?vue&type=template&id=2300bef7&"
import script from "./DeleteDrinkDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDrinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports